import { useCallback } from 'react';
import { FilterFieldType, FiltersFormValues } from '../admin/components/FiltersForm';
import { NumberFilterType, StringFilterType } from '../admin/components/FiltersGroup';

function getCondition(rule: {
  value?: string;
  mode: StringFilterType | NumberFilterType;
  field: string;
  type: FilterFieldType;
}) {
  if (rule.mode === 'equals:null' || rule.mode === 'not:null') {
    return { [rule.mode === 'equals:null' ? 'equals' : 'not']: null };
  }
  if (rule.type === 'date') {
    return rule.value;
  }
  if (rule.type === 'select') {
    if (rule.field === 'merchant.isApproved' || rule.field === 'isApproved') {
      return { equals: rule.value === 'true' };
    }
    return { equals: rule.value };
  }

  if (rule.type === 'string') {
    const normalizedValue = rule.value ? rule.value.trim().replace(/\s+/g, ' ') : rule.value;
    return {
      [rule.mode]: normalizedValue,
      mode: 'insensitive',
    };
  }

  if (rule.type === 'number') {
    return {
      [rule.mode]: Number(rule.value),
    };
  }

  return { [rule.mode]: rule.value };
}

function getDeepCondition(rule: {
  value?: string;
  mode: StringFilterType | NumberFilterType;
  field: string;
  type: FilterFieldType;
}) {
  const fieldParts = rule.field.split('.');
  let condition = {};
  if (fieldParts.length > 1) {
    let temp = {};
    temp[fieldParts[fieldParts.length - 1]] = getCondition(rule);

    condition = fieldParts
      .slice(0, -1)
      .reverse()
      .reduce((acc, key) => ({ [key]: acc }), temp);
  } else {
    condition[rule.field] = getCondition(rule);
  }
  return condition;
}

const useFiltersProcessor = () => {
  const processFilters = useCallback((rawFilters?: FiltersFormValues) => {
    if (!rawFilters) return {};
    const output: {
      OR: unknown[];
      AND: unknown[];
    } = {
      OR: [],
      AND: [],
    };

    rawFilters.filters.forEach((filter) => {
      filter.rules.forEach((rule) => {
        const condition = getDeepCondition(rule as any);
        filter.mode === 'AND' ? output.AND.push(condition) : output.OR.push(condition);
      });
    });

    return output;
  }, []);

  return { processFilters };
};

export default useFiltersProcessor;
